import React from "react";
import { Heading, Text } from "@chakra-ui/react";
import type { MarkdownToJSX } from "markdown-to-jsx";
import Markdown from "markdown-to-jsx";
import { Link } from "components/Link";
import { colours } from "@shared/ui.design-system";

type Props = MarkdownToJSX.Options & {
  usePearlStyles?: boolean;
  content: string;
};

const markDownStyles = {
  variant: "acuminLight",
  mt: 0,
  whiteSpace: "pre-line",
  css: {
    "& span:first-of-type": { marginTop: "0" }
  }
};

const removeParagraph = (content: string): string => {
  let newContent = content;
  try {
    newContent = newContent
      .replace(/<p>/g, "<span>")
      .replace(/<\/p>/g, "</span>");
  } catch (err) {
    console.error(err);
  }
  return newContent;
};

export const GenericMarkdown: React.FC<Props> = ({
  usePearlStyles = false,
  content,
  ...options
}) => {
  return (
    <Markdown
      as="span"
      data-testid="GenericMarkdown"
      options={{
        overrides: {
          span: {
            component: Text,
            props: {
              as: "span",
              ...markDownStyles,
              ...(usePearlStyles
                ? {
                    color: colours.primary.medium
                  }
                : {})
            }
          },
          p: {
            component: Text,
            props: {
              ...markDownStyles,
              ...(usePearlStyles
                ? {
                    color: colours.primary.medium
                  }
                : {})
            }
          },
          h1: {
            component: Heading,
            props: {
              ...markDownStyles,
              variant: "acuminMedium",
              fontSize: "20px",
              lineHeight: "28px",
              textTransform: "uppercase",
              marginBottom: -1,
              as: "h1",
              ...(usePearlStyles
                ? {
                    color: colours.primary.dark
                  }
                : {})
            }
          },
          h2: {
            component: Heading,
            props: {
              ...markDownStyles,
              variant: "acuminMedium",
              fontSize: "16px",
              lineHeight: "24px",
              textTransform: "uppercase",
              marginBottom: -1,
              marginTop: 2,
              as: "h2",
              ...(usePearlStyles
                ? {
                    color: colours.primary.dark
                  }
                : {})
            }
          },
          a: {
            component: Link,
            props: {
              variant: "acuminMedium",
              fontFamily: "inherit",
              fontSize: "inherit",
              ...(usePearlStyles
                ? {
                    fontWeight: "500",
                    textDecoration: "underline",
                    textTransform: "capitalize"
                  }
                : {})
            }
          }
        },
        ...options
      }}
    >
      {removeParagraph(content)}
    </Markdown>
  );
};
